export default "__VITE_ASSET__BfN08bGg__"